<template>
	<div>
		<div class="table-responsive">
			<table class="table table-striped table-bordered">
				<thead>
					<tr>
						<th scope="col" colspan="6">
							<form v-on:submit.prevent="search()">
								<div class="input-group">
									<input type="text" class="form-control" v-bind:placeholder="Translate('@_UI_SEARCH')" aria-describedby="button-notifications-search" ref="searchTerm" />
									<div class="input-group-append" v-if="String(filter).trim() !== ''">
										<button type="button" class="btn btn-outline-danger" aria-label="Close" v-on:click.prevent="clearFilter()">
											<span aria-hidden="true">&times;</span>
										</button>
									</div>
									<div class="input-group-append">
										<button class="btn btn-primary" type="submit" id="button-notifications-search" v-html="Translate('@_UI_SEARCH')"></button>
									</div>
								</div>
							</form>
							<div class="mt-2">
								<button type="button" class="btn btn-outline-dark ml-1 mr-1" v-html="'Επισήμανση ως Διαβασμένα Όλα'" v-on:click.prevent="readAllNotifications($event)"></button>
							</div>
						</th>
					</tr>
					<tr>
						<th scope="col" class="cursor-pointer" v-on:click="changeSort('id')">
							<span>#</span>
							&nbsp;
							<i class="arrow" v-bind:class="{ down: sorting.dir === 'DESC', up: sorting.dir === 'ASC' }" v-if="sorting.field === 'id'"></i>
						</th>
						<th scope="col">
							<span v-html="Translate('@_NOTIFICATION')"></span>
						</th>
						<th scope="col" class="cursor-pointer" v-on:click="changeSort('title')">
							<span v-html="Translate('@_THESIS')"></span>
							&nbsp;
							<i class="arrow" v-bind:class="{ down: sorting.dir === 'DESC', up: sorting.dir === 'ASC' }" v-if="sorting.field === 'title'"></i>
						</th>
						<th scope="col" class="cursor-pointer" v-on:click="changeSort('name')">
							<span v-html="Translate('@_UI_NOTIFICATION_SENDER_NAME')"></span>
							&nbsp;
							<i class="arrow" v-bind:class="{ down: sorting.dir === 'DESC', up: sorting.dir === 'ASC' }" v-if="sorting.field === 'name'"></i>
						</th>
						<!-- <th scope="col" class="cursor-pointer" v-on:click="changeSort('email')">
							<span v-html="Translate('@_UI_NOTIFICATION_SENDER_EMAIL')"></span>
							&nbsp;
							<i class="arrow" v-bind:class="{ down: sorting.dir === 'DESC', up: sorting.dir === 'ASC' }" v-if="sorting.field === 'email'"></i>
						</th> -->
						<th scope="col" class="cursor-pointer" v-on:click="changeSort('created_at')">
							<span v-html="Translate('@_UI_NOTIFICATION_CREATED_DATE')"></span>
							&nbsp;
							<i class="arrow" v-bind:class="{ down: sorting.dir === 'DESC', up: sorting.dir === 'ASC' }" v-if="sorting.field === 'created_at'"></i>
						</th>
						<th scope="col">&nbsp;</th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="results.length === 0">
						<td colspan="6">
							<div class="alert alert-warning" role="alert" v-html="Translate('@_UI_NO_RESULTS_FOUND')"></div>
						</td>
					</tr>
				</tbody>
				<tbody>
					<tr v-for="(result, index) in results" v-bind:key="index" v-bind:class="{ 'font-weight-bold': result.is_read === 0 }">
						<th scope="row">
							<router-link v-bind:to="{ name: 'notification', params: { id: result.id } }" v-html="result.id"></router-link>
						</th>
						<td v-if="result.notification.text == 'undefined'" v-html="Translate(result.notification.title).replaceArray(result.notification.find || [], result.notification.replace || [])"></td>
						<td
							v-if="result.notification.text != 'undefined'"
							v-html="Translate(result.notification.title).replaceArray(result.notification.find || [], result.notification.replace || []) + '  ' + (result.notification.id != null ? result.notification.id : '')"
						></td>
						<router-link v-bind:to="{ name: 'thesis_view', params: { id: result.thesis_id } }" v-html="result.thesis_title + '</br>(code: ' + result.thesis_code + ')'"></router-link>
						<td v-html="result.sender_name + ' (' + Translate('@_USER_TYPE_' + result.sender_kind) + ')'"></td>
						<td v-html="result.created_at"></td>
						<button type="button" class="btn btn-dark ml-1 mr-1" v-html="Translate('@_DELETE')" v-on:click.prevent="deleteData(result.id)"></button>
					</tr>
				</tbody>
				<tfoot v-if="current_page !== null && total_pages !== null && total_results !== null && total_results !== 0">
					<tr>
						<td colspan="6">
							<nav aria-label="Page navigation">
								<ul class="pagination justify-content-end">
									<li class="page-item" v-bind:class="{ disabled: current_page <= 1 }">
										<a class="page-link" href="javascript: void(0);" aria-label="Previous" v-on:click="goToPage(current_page - 1)">
											<span aria-hidden="true">&laquo;</span>
											<span class="sr-only" v-html="Translate('@_UI_PREVIOUS')"></span>
										</a>
									</li>
									<li class="page-item" v-for="page in total_pages" v-bind:key="page" v-bind:class="{ active: page === current_page }">
										<a class="page-link" href="javascript: void(0);" v-html="page" v-on:click="goToPage(page)"></a>
									</li>
									<li class="page-item" v-bind:class="{ disabled: current_page >= total_pages }">
										<a class="page-link" href="javascript: void(0);" aria-label="Next" v-on:click="goToPage(current_page + 1)">
											<span aria-hidden="true">&raquo;</span>
											<span class="sr-only" v-html="Translate('@_UI_NEXT')"></span>
										</a>
									</li>
								</ul>
							</nav>
						</td>
					</tr>
				</tfoot>
			</table>
		</div>
	</div>
</template>

<script>
import Mixin from "@/helpers/mixin";

export default {
	name: "NotificationsTable",
	mixins: [Mixin],
	data() {
		return {
			filter: "",
			sorting: {
				field: "id",
				dir: "DESC"
			},
			current_page: null,
			total_pages: null,
			results_per_page: null,
			total_results: null,
			results: []
		};
	},
	computed: {
		__watcher_sorting_field() {
			return this.sorting.field;
		},
		__watcher_sorting_dir() {
			return this.sorting.dir;
		}
	},
	methods: {
		readAllNotifications(event) {
			var r = confirm(this.Translate("@_ARE_YOU_SURE"));
			if (r !== true) {
				return;
			}
			event.target.disabled = true;
			this.getData(1, "", this.sorting, 1);
			event.target.disabled = false;
			this.$router.go(0);
		},
		search() {
			let term = String(this.$refs.searchTerm.value).trim();
			this.$refs.searchTerm.value = term;
			this.filter = term;
		},
		clearFilter() {
			this.filter = "";
			this.$refs.searchTerm.value = "";
		},
		goToPage(InPage) {
			if (InPage < 1) {
				InPage = 1;
			}
			if (InPage > this.total_pages) {
				InPage = this.total_pages;
			}
			this.current_page = InPage;
		},
		changeSort(InField) {
			let field = String(InField).trim();
			if (this.sorting.field !== field) {
				this.sorting.field = field;
				this.sorting.dir = "DESC";
			} else {
				this.sorting.dir = this.sorting.dir === "DESC" ? "ASC" : "DESC";
			}
		},
		getData(InPage, InFilter, InSorting, ReadAll = 0) {
			const _this = this;
			this.$store
				.dispatch("http_get_notifications", {
					page: parseInt(InPage),
					search: String(InFilter).trim(),
					order: String(InSorting.field).trim(),
					dir: String(InSorting.dir)
						.trim()
						.toUpperCase(),
					readall: ReadAll
				})
				.then(resp => {
					// console.log(resp);
					_this.current_page = typeof resp.current_page !== "undefined" ? parseInt(resp.current_page) : 1;
					_this.total_pages = typeof resp.total_pages !== "undefined" ? parseInt(resp.total_pages) : 1;
					_this.results_per_page = typeof resp.results_per_page !== "undefined" ? parseInt(resp.results_per_page) : 1;
					_this.total_results = typeof resp.total_results !== "undefined" ? parseInt(resp.total_results) : 1;
					_this.results = typeof resp.results !== "undefined" ? resp.results : [];
				})
				.catch(e => {
					console.error(e);
				});
		},
		deleteData(InId) {
			this.$store
				.dispatch("http_delete_notification", {
					id: parseInt(InId)
				})
				.then(() => {
					this.results.splice(this.results[InId], 1);
				})
				.catch(e => {
					this.ShowAlert("alert-danger", this.Translate("@_GENERAL_ERROR"), 5000);
					console.error(e);
				});
		}
	},
	watch: {
		__watcher_sorting_field: {
			handler(newVal, oldVal) {
				if (newVal != oldVal) {
					this.getData(1, this.filter, this.sorting);
				}
			}
		},
		__watcher_sorting_dir: {
			handler(newVal, oldVal) {
				if (newVal != oldVal) {
					this.getData(1, this.filter, this.sorting);
				}
			}
		},
		filter: {
			handler(newVal, oldVal) {
				if (newVal != oldVal) {
					if (String(newVal).trim().length >= 5) {
						this.getData(1, String(newVal).trim(), this.sorting);
					} else {
						this.getData(1, "", this.sorting);
					}
				}
			}
		},
		current_page: {
			handler(newVal, oldVal) {
				if (newVal != oldVal) {
					this.getData(newVal, this.filter, this.sorting);
				}
			}
		}
	},
	created() {
		this.getData(1, "", this.sorting);
	}
};
</script>

<style scoped></style>
